import { type IValidator } from "types/apiResponse/apiResponse";

export const getValidator = function (validatorResponse: IValidator[], type: string): IValidator {
    return validatorResponse.filter((val: IValidator) => val.type === type)[0];
};

const getValidatorValue = function (
    validatorResponse: IValidator[],
    type: string,
    defaultValue: boolean,
): boolean {
    const validator = getValidator(validatorResponse, type);

    if (validator === undefined) {
        return defaultValue;
    }

    return validator.value as boolean;
};

export const getReadOnly = function (validatorResponse: IValidator[]): boolean {
    return getValidatorValue(validatorResponse, "readonly", false);
};
